module.exports = __webpack_public_path__ + "images/479c23a.png";